export enum DialogTitleTypeEnum {
  PRIMARY = 'primary',
  NEUTRAL = 'neutral',
}

export type DialogTitleTypeEnumValues = `${DialogTitleTypeEnum}`;
